const identifier_cache: { [key: string]: string } = {};

export default function (identifier: string): string {
	let escaped_identifier = identifier_cache[identifier];
	if (escaped_identifier === void 0) {
		escaped_identifier = identifier.replace(/[^a-zA-Z0-9_]/g, "_").replace(/^[0-9]+$/, "_" + identifier);
		if (reserved_keywords.has(escaped_identifier)) {
			escaped_identifier = escaped_identifier + "_";
		}
		identifier_cache[identifier] = escaped_identifier;
	}
	return escaped_identifier;
}

const reserved_keywords = new Set([
	"break",
	"case",
	"catch",
	"class",
	"const",
	"continue",
	"debugger",
	"default",
	"delete",
	"do",
	"else",
	"enum",
	"export",
	"extends",
	"false",
	"finally",
	"for",
	"function",
	"if",
	"import",
	"in",
	"instanceof",
	"new",
	"null",
	"return",
	"super",
	"switch",
	"this",
	"throw",
	"true",
	"try",
	"typeof",
	"var",
	"void",
	"while",
	"with",
	"as",
	"implements",
	"interface",
	"let",
	"package",
	"private",
	"protected",
	"public",
	"static",
	"yield",
]);
